import { FieldLabel } from "@/components/forms/FormField";
import { Select } from "@/components/ui/select";

/** Label + Select + help/error, the select counterpart of FormField. */
export default function SelectField({ id, name, label, required = false, error, help, note, ...selectProps }) {
  const errorText = Array.isArray(error) ? error[0] : error;
  const fieldId = id || name;
  const describedBy = [help && `${fieldId}-help`, errorText ? `${fieldId}-error` : note && `${fieldId}-note`].filter(Boolean).join(" ") || undefined;

  return (
    <div className="space-y-2">
      <FieldLabel fieldId={fieldId} label={label} required={required} help={help} />
      <Select
        id={fieldId}
        name={name}
        required={required}
        aria-invalid={!!errorText}
        aria-describedby={describedBy}
        className={errorText ? "border-destructive focus-visible:ring-destructive" : ""}
        {...selectProps}
      />
      {errorText && <p id={`${fieldId}-error`} className="text-sm text-destructive">{errorText}</p>}
      {!errorText && note && <p id={`${fieldId}-note`} className="text-sm text-muted-foreground">{note}</p>}
    </div>
  );
}
